import { defineSlotRecipe } from '@chakra-ui/react'
import { switchAnatomy } from '@chakra-ui/react/anatomy'

export const switchSlotRecipe = defineSlotRecipe({
    slots: switchAnatomy.keys(),
    variants: {
        variant: {
            gigi: {
                control: {
                    height: '24px',
                    width: '40px',
                    bg: 'transparent',
                    border: '2px solid',
                    borderColor: 'dark.700',
                    _dark: {
                        bg: 'white',
                    },
                    _checked: {
                        bg: 'dark.700',
                        _dark: {
                            bg: 'white',
                        },
                    },
                },
                thumb: {
                    background: 'dark.700',
                    height: '12px',
                    width: '12px',
                    mt: '4px',
                    ml: '4px',
                    _dark: {
                        bg: 'dark.700',
                    },
                    _checked: {
                        bg: 'white',
                        height: '16px',
                        width: '16px',
                        mt: '2px',
                        ml: '-4px',
                        _dark: {
                            bg: 'dark.700',
                        },
                    },
                },
            },
        },
    },
})
